import Container from 'react-bootstrap/Container';
import MainNav from './layout/Navbar';
import Footer from './sections/section-7-footer';
import InfoCards from './sections/section-3-info-cards';
import Hero from './sections/section-2-hero';
// import CustomerInfo from './sections/section-6-customer-info';
import Retro from './sections/section-4-retro';
import Contact from './sections/section-5-contact-form';
import { useEffect } from 'react';
import axios from './api/api'

function App() {
  useEffect(() => {
    axios.get('/health-check', { headers: { 'Content-Type': 'application/json' } })
      .then(res => {
        console.log(res.data);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);
  return (
    <Container fluid>
      <MainNav />
      <Hero />
      <InfoCards />
      <Retro />
      <Contact />
      {/* <CustomerInfo /> */}
      <Footer />
    </Container>
  );
}

export default App;